export default __webpack_public_path__ + "static/media/sandero-colour-5.c53852eb.jpg";